var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!./notification-scroll.ts"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-7de16834\"}!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./notification-scroll.vue.html"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/notification/notification-scroll/notification-scroll.vue.html
// module id = HqTE
// module chunks = 2